<template>
  <div class="special-line-list-container">
    <div class="jc-page-top">
      <div class="instance-list">
        <div class="jc-page-header">
          <h1><i class="jc-icon-my-circle-bold"></i>{{ $t("directConnects.title") }}</h1>
          <div class="jc-box-action"></div>
        </div>
        <div class="jc-page-content">
          <!-- SearchListPane组件 -->
          <SearchListPane
            ref="searchPane"
            :search-configs="searchConfigs"
            :search-form-data="searchForm"
            @search="handleSearch"
            @reset="handleReset"
            :default-visible-count="3"
            :show-collapse-button="true"
          />
          <div class="el-container-table common-table-container">
            <!-- 表头操作 -->
            <div class="el-container-table-actionBar">
              <el-form class="el-table-actionBar-item" :inline="true">
                <el-form-item>
                  <el-button
                    icon="jc-icon-refresh-line"
                    class="el-button-icon"
                    @click="updateList"
                    :disabled="refreshloading"
                  ></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <!-- 标签过滤器（暂时注释，专线可能不需要标签功能）-->
                <el-form-item class="set-icon">
                  <jcb-tag-filter
                    :service-code="ServiceCodeConstant.CCS"
                    :visible.sync="batchEditTagDialogVisible"
                    :region-id="TagRegionID"
                    @checkedTags="filterWithCheckedTags"
                  >
                  </jcb-tag-filter>
                </el-form-item>

                <el-form-item class="set-icon">
                  <el-button
                    icon="el-icon-setting"
                    class="el-button-icon"
                    @click="setCustom"
                    :title="$t('merge.customList')"
                  ></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button
                    icon="jc-icon-download"
                    class="el-button-icon"
                    @click="exportList"
                    :title="$t('speechcraft.exportResourceList')"
                  ></el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- 表格 -->
            <div class="el-container-table">
              <el-table
                :data="tableData"
                tooltip-effect="light"
                ref="table"
                v-loading="refreshloading"
                :empty-text="tableEmptyTip"
                @selection-change="handleSelectionChange"
              >
                <!-- 复选框列 -->
                <el-table-column
                  type="selection"
                  width="55"
                  v-if="customInfo !== null">
                </el-table-column>
                
                <!-- ID -->
                <el-table-column
                  prop="directConnectId"
                  key="directConnectId"
                  min-width="130"
                  :label="$t('directConnects.directConnectId')"
                  fixed
                  v-if="getCustomInfoSelect('directConnectId')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.directConnectId | maybeEmpty }}</span>
                  </template>
                </el-table-column>
                <!-- 专线名称 -->
                <el-table-column
                  prop="directConnectName"
                  key="directConnectName"
                  min-width="150"
                  :label="$t('directConnects.directConnectName')"
                  fixed
                  v-if="getCustomInfoSelect('directConnectName')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.directConnectName | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- A端机房名称 -->
                <el-table-column
                  prop="datacenterNameA"
                  key="datacenterNameA"
                  min-width="150"
                  :label="$t('directConnects.datacenterNameA')"
                  v-if="getCustomInfoSelect('datacenterNameA')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.datacenterNameA | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- B端机房名称 -->
                <el-table-column
                  prop="datacenterNameB"
                  key="datacenterNameB"
                  min-width="150"
                  :label="$t('directConnects.datacenterNameB')"
                  v-if="getCustomInfoSelect('datacenterNameB')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.datacenterNameB | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 资源类型 -->
                <el-table-column
                  prop="resourceTypeName"
                  key="resourceTypeName"
                  min-width="120"
                  :label="$t('directConnects.resourceType')"
                  v-if="getCustomInfoSelect('resourceTypeName')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.resourceTypeName | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 资源用量 -->
                <el-table-column
                  prop="resourceUsage"
                  key="resourceUsage"
                  min-width="120"
                  :label="$t('directConnects.resourceUsage')"
                  v-if="getCustomInfoSelect('resourceUsage')"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.resourceUsage | maybeEmpty  }}</span>
                  </template>
                </el-table-column>
                <!-- 计费信息 -->
                <el-table-column
                  key="billingInfo"
                  min-width="180"
                  :label="$t('directConnects.billingInfo')"
                  v-if="getCustomInfoSelect('billingInfo')"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ $t("directConnects.billingTime") }}: {{ scope.row.startTime | maybeEmpty }}
                    </div>
                    <div>
                      {{ $t("directConnects.expireTime") }}: {{ scope.row.endTime | maybeEmpty }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column 
                    :label="$t('text.tags')"
                    key="tags"
                    v-if="getCustomInfoSelect('tags')"
                    min-width="120"
                    class-name="p-line-break">
                  <template slot-scope="scope">
                    <p>{{scope.row.tagPairs | maybeEmpty}}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <custom
          :visible.sync="customVisible"
          v-if="customVisible"
          :optionArr="optionArr"
          :type="type"
        ></custom>
      </div>
    </div>
    <div
      class="el-page-footer block el-container-table-actionBar"
      v-if="tableData.length"
    >
      <el-tooltip
        class="item"
        effect="dark"
        :content="$t('text.pleaseSelectResource')"
        :disabled="!!multipleSelection.length"
        :visible-arrow="false"
        placement="top"
      >
        <el-button
          type="primary"
          :disabled="!multipleSelection.length"
          @click="batchEditTag"
        >
          {{$t('text.editTag')}}
        </el-button>
      </el-tooltip>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizeArr"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!--编辑标签-->
    <jcb-tag-edit
      :visible.sync="editTagDialogVisible"
      :service-code="ServiceCodeConstant.CCS"
      :region-id="TagRegionID"
      :resource-ids="resourceId"
      @complete="updateList"
    >
    </jcb-tag-edit>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import custom from "../common/custom/Custom.vue";
import SearchListPane from "../common/search/SearchListPane.vue";
import searchOperate from "@/mixins/searchOperate";
import { ServiceCodeConstant } from "@/common/Constants";
import customInfoSelect from '@/mixins/customInfoSelect';

export default {
  name: "SpecialLineList",
  components: {
    custom,
    SearchListPane,
  },
  mixins: [searchOperate, customInfoSelect],
  data() {
    return {
      refreshloading: false,
      tableData: [],
      tableEmptyTip: "",
      tableEmptyMap: {
        noSearch: this.$t("text.noSearch"),
        hasSearch: this.$t("text.hasSearch"),
      },
      customVisible: false,
      type: 'directConnect',
      // 分页相关数据
      currentPage: 1, // 当前页数
      pageSize: 20, // 当前显示数据个数
      pageSizeArr: [20, 50, 100], // 每页显示总数
      total: 0, // 数据总数
      multipleSelection: [],

      // SearchListPane配置
      searchConfigs: [
        {
          field: "directConnectName",
          type: "input",
          label: this.$t("directConnects.directConnectName"),
          placeholder: this.$t('placeholder.placeholderInput', [this.$t("directConnects.directConnectName")]),
        },
        {
          field: "datacenterNameA",
          type: "input",
          label: this.$t("directConnects.datacenterNameA"),
          placeholder: this.$t('placeholder.placeholderInput', [this.$t("directConnects.datacenterNameA")]),
        },
        {
          field: "datacenterNameB",
          type: "input",
          label: this.$t("directConnects.datacenterNameB"),
          placeholder: this.$t('placeholder.placeholderInput', [this.$t("directConnects.datacenterNameB")]),
        },
        {
          field: "directConnectId",
          type: "input",
          label: this.$t("directConnects.directConnectId"),
          placeholder: this.$t('placeholder.placeholderInputMore', [this.$t("directConnects.directConnectId")]),
        },
        {
          field: "resourceType",
          type: "multiple-select",
          label: this.$t("directConnects.resourceType"),
          placeholder: this.$t('placeholder.placeholderSelectMore', [this.$t("directConnects.resourceType")]),
          options: [],
        },
      ],
      searchForm: {
        directConnectName: "", // 专线名称
        datacenterNameA: "", // A端机房名称
        datacenterNameB: "", // B端机房名称
        directConnectId: "", // ID
        resourceType: [], // 资源类型
      },

      // 自定义列选项
      optionArr: [
        { label: this.$t("directConnects.directConnectId"), value: "directConnectId" },
        { label: this.$t("directConnects.directConnectName"), value: "directConnectName" },
        { label: this.$t("directConnects.datacenterNameA"), value: "datacenterNameA" },
        { label: this.$t("directConnects.datacenterNameB"), value: "datacenterNameB" },
        { label: this.$t("directConnects.resourceType"), value: "resourceTypeName" },
        { label: this.$t("directConnects.resourceUsage"), value: "resourceUsage" },
        { label: this.$t("directConnects.billingInfo"), value: "billingInfo" },
        { label: this.$t('text.tags'), value: 'tags' },
      ],
      // 编辑标签组件是否显示
      editTagDialogVisible: false,
      // 批量编辑标签组件是否显示
      batchEditTagDialogVisible: true,
      resourceId: [],
      // 标签过滤后的资源ID
      filteredResourceIds: [],
    };
  },
  computed: {
    ServiceCodeConstant: () => ServiceCodeConstant,
    // vuex中获取自定义信息
    customInfo() {
      return this.$store.state.customInfo[this.type];
    },
    // vuex中获取bandwidth状态
    filterList () {
      return this.$store.state.filter.filterList;
    },
  },
  created() {
    this.updateList();
    this.initSearchOptions();
    if (!this.$store.state.customInfo[this.type]) {
      this.getCustomInfo();
    }
  },
  methods: {
    initSearchOptions() {
      const resourceTypeOptions = (this.filterList && this.filterList.directConnectResourceType) ? [...this.filterList.directConnectResourceType] : [];
      this.searchConfigs = this.searchConfigs.map(config => {
        if (config.field === 'resourceType') {
          return { ...config, options: resourceTypeOptions };
        }
        return config;
      });
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.updateList();
    },
    // 当前页码改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateList();
    },
    async updateList() {
      this.refreshloading = true;
      try {
        const params = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
        };

        // 使用 for...in 处理搜索参数
        for (const key in this.searchForm) {
          const value = this.searchForm[key];
          if (Array.isArray(value)) {
            // 数组类型（如机房名称、资源类型），有值时 join
            if (value.length > 0) {
              params[key] = value.join(',');
            }
          } else if (typeof value === 'string') {
            const trimmedValue = value.trim();
            if (trimmedValue !== '') {
              // 特殊处理 ID 字段（支持空格分隔多个 ID）
              if (key === 'directConnectId') {
                const ids = trimmedValue.split(/\s+/);
                if (ids.length > 1) {
                  params[key] = ids.join(' '); // 多个 ID 精确搜索
                } else {
                  params[key] = ids[0]; // 单个 ID 模糊搜索
                }
              } else {
                // 其他字符串字段（如 name）直接赋值
                params[key] = trimmedValue;
              }
            }
          }
        }

        // 是否通过标签进行筛选
      if (this.filteredResourceIds.length) {
        params.directConnectId = this.filteredResourceIds.join(' ');
      }

        const res = await this.$api.describeResourceDirectConnects(params);
        if (res.errno === 10000 && res.data) {
          const { directConnects, totalCount } = res.data;
          this.tableData = directConnects || [];
          this.total = totalCount || 0;
          this.tableData.forEach((item) => {
            item.tagPairs = '';
            if (item.tags !== undefined && item.tags.length > 0) {
              item.tags.forEach((tag) => {
                item.tagPairs += `${tag.key}:${tag.value},`;
              });
              item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
            }
          });
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.errmsg || '获取数据失败');
        }
      } catch (e) {
        this.tableData = [];
        this.total = 0;
        this.tableEmptyTip = this.tableEmptyMap.noSearch;
      } finally {
        this.refreshloading = false;
      }
    },

    /**
     **@disc: 根据标签对实例进行过滤
     */
    filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
      console.log(filterTags, tagKeys, resourceIds);
      if (tagKeys.length !== 0) {
        this.filteredResourceIds = resourceIds;
      } else {
        this.filteredResourceIds = [];
      }
      this.updateList();
    },

    setCustom() {
      this.customVisible = true;
    },

    // 获取自定义信息
    getCustomInfo() {
      const param = {
        pageKey: this.type,
      };
      this.$api.getCustomInfo(param).then((res) => {
        if (res.errno === 10000 && res.data.customInfo) {
          this.$store.commit("GET_CUSTOMINFO", {
            value: res.data.customInfo,
            type: this.type,
          });
        }
      });
    },

    batchEditTag() {
      this.resourceId = (this.multipleSelection || []).map(item => item.directConnectId).filter(Boolean);
      if (!this.resourceId.length) {
        return;
      }
      this.editTagDialogVisible = true;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    exportList() {
      const params = [];
      // 使用 for...in 处理搜索参数
      for (const key in this.searchForm) {
        const value = this.searchForm[key];
        if (Array.isArray(value)) {
          // 数组类型（如机房名称、资源类型），有值时 join
          if (value.length > 0) {
            params.push(`${key}=${value.join(',')}`);
          }
        } else if (typeof value === 'string') {
          const trimmedValue = value.trim();
          if (trimmedValue !== '') {
            // 特殊处理 ID 字段（支持空格分隔多个 ID）
            if (key === 'directConnectId') {
              const ids = trimmedValue.split(/\s+/);
              if (ids.length > 1) {
                params.push(`${key}=${ids.join(' ')}`);
              } else {
                params.push(`${key}=${ids[0]}`);
              }
            } else {
              // 其他字符串字段（如 name）直接赋值
              params.push(`${key}=${trimmedValue}`);
            }
          }
        }
      }

      if (this.filteredResourceIds.length) {
        params.push(`directConnectId=${this.filteredResourceIds.join(' ')}`);
      }

      let url = '/ccs-api/api/resource/exportDirectConnects?all=1';
      if (params.length > 0) {
        url += '&' + params.join('&');
      }

      console.log(url);
      window.open(url, '_self');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./list.scss";
</style>



// WEBPACK FOOTER //
// src/components/directConnects/DirectConnectsList.vue